import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<React.StrictMode data-id="element-270">
    <App data-id="element-271" />
  </React.StrictMode>);